@import './cpsl-row.vars';

// Row
// --------------------------------------------------

:host {
  display: flex;

  flex-wrap: wrap;
}
